import React from 'react';

import Anchor from '../../components/Anchor/Anchor';
import { colors } from '../../styles/colors';
import LinkViewModel from '../../view-models/LinkViewModel';
import { navigationLinkStyle } from './Header';
import ServiceMenu, {
  AuthMenuLink,
  getMobileMenuItemStyle,
} from './ServiceMenu';

export type NavigationProps = {
  links: LinkViewModel[];
  inverted?: boolean;
  loggedIn?: boolean;
  onClick?: () => void;
  serviceMenuLinks?: LinkViewModel[];
  showAuthLink?: boolean;
  staggerItems?: boolean;
};

function Navigation({
  links,
  inverted,
  loggedIn,
  onClick,
  serviceMenuLinks,
  showAuthLink = true,
  staggerItems,
}: NavigationProps) {
  const backgroundColor = inverted
    ? colors.components.fixedTop.Background.Open
    : colors.components.fixedTop.Background.Default;
  const textColor = inverted
    ? colors.components.fixedTop.Text.Open
    : colors.components.fixedTop.Text.Default;

  return (
    <>
      <ServiceMenu
        inverted={inverted}
        links={serviceMenuLinks}
        onClick={onClick}
        staggerItems={staggerItems}
      />
      {links.map((link, key) => (
        <Anchor
          prefetch
          key={key}
          onClick={onClick}
          style={
            staggerItems
              ? getMobileMenuItemStyle((serviceMenuLinks?.length ?? 0) + key)
              : undefined
          }
          sx={{
            display: ['block', 'inline-block'],
            background: [backgroundColor, 'transparent'],
            borderBottom: ['1px solid', 'none'],
            fontFamily: 'heading',
            ...navigationLinkStyle,
            color: textColor,
            borderBottomColor: [backgroundColor, 'transparent'],
            '&:hover': { ...navigationLinkStyle['&:hover'], color: textColor },
          }}
          {...link}
        />
      ))}
      {showAuthLink && (
        <AuthMenuLink
          inverted={inverted}
          loggedIn={loggedIn}
          onClick={onClick}
        />
      )}
    </>
  );
}

export default Navigation;
